import { ActiveOrganization, useStandingOfferCreate } from "@/api";
import { useToast } from "@/components/ui/use-toast";
import { StandingOfferCreateMutationVariables } from "@/gql/__generated__/graphql";
import { TRIAL_DAYS } from "@/utils/subscriptionOfferTrialDays";
import { FormEvent } from "react";

export function useHandleSubmitStandingOffer(
  organization?: ActiveOrganization
) {
  const [standingOfferCreate, { loading }] = useStandingOfferCreate();
  const { toast } = useToast();

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const appSlug = (formData.get("app") as string) || undefined;
    const message = (formData.get("message") as string) || undefined;
    const reference = (formData.get("reference") as string) || undefined;
    const price = formData.get("price")
      ? parseFloat(formData.get("price") as string)
      : undefined;
    const trialEnabled = formData.get("trial-toggle") === "on";

    if (!organization?.id || !appSlug) return undefined;

    let variables: StandingOfferCreateMutationVariables = {
      organizationId: organization.id,
      input: {
        appSlug,
        message,
        name: reference
      }
    };

    if (price !== undefined) {
      if (price < 10) {
        toast({
          title: "Subscription fee must be greater than $10",
          variant: "destructive"
        });
        return undefined;
      }

      variables.input.payment = {
        monthlyPriceUSD: price.toString(),
        trialDays: trialEnabled ? TRIAL_DAYS : null
      };
    }

    return standingOfferCreate({ variables })
      .then((res) => {
        if (res.data?.standingOfferCreate.__typename === "StandingOffer") {
          toast({
            title: "Standing offer created"
          });
        }
        return res;
      })
      .catch((mutationError) => {
        console.error("Create standing offer mutation error", mutationError);
        toast({
          title: "Unable to create standing offer",
          description:
            "An error occurred while creating the standing offer. Please try again or report the issue",
          variant: "destructive"
        });
      });
  }

  return { handleSubmit, loading };
}
